import React from "react";
import { useBooking } from "./BookingContext";

const NAV = [
  { label: "The Formula", href: "#formula" },
  { label: "Projects", href: "#projects" },
  { label: "Journal", href: "#journal" },
];

const SOCIAL = [
  { label: "Instagram", href: "https://instagram.com" },
  { label: "LinkedIn", href: "https://linkedin.com" },
  { label: "hello@epeeka.studio", href: "mailto:hello@epeeka.studio" },
];

export default function Footer() {
  const { openBooking } = useBooking();
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer id="journal" data-testid="site-footer" className="relative bg-charcoal text-warm">
      <div className="mx-auto max-w-[1600px] px-6 py-20 md:px-12 md:py-28">
        <div className="grid grid-cols-1 gap-16 md:grid-cols-12">
          <div className="md:col-span-6">
            <span className="font-serif text-4xl md:text-5xl">
              Studio of EMA<span className="text-copper">.</span>
            </span>
            <p className="mt-6 max-w-[34ch] leading-relaxed text-warm/55">
              A private consultancy creating luxury legacy villas — assets designed to be
              remembered, lived in, and passed on.
            </p>
            <button
              data-testid="footer-cta"
              onClick={openBooking}
              className="link-underline mt-8 inline-block font-serif text-2xl italic text-champagne"
            >
              Book Your Strategy Call
            </button>
          </div>

          <div className="md:col-span-3">
            <span className="overline text-warm/40">Explore</span>
            <ul className="mt-6 space-y-4">
              {NAV.map((n) => (
                <li key={n.href}>
                  <button onClick={() => go(n.href)} className="link-underline text-warm/80">
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <span className="overline text-warm/40">Connect</span>
            <ul className="mt-6 space-y-4">
              {SOCIAL.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-underline text-warm/80"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-20 flex flex-col justify-between gap-4 border-t border-warm/10 pt-8 text-xs text-warm/40 md:flex-row">
          <span>&copy; {new Date().getFullYear()} Studio of EMA. All rights reserved.</span>
          <span className="overline">The Luxury Legacy Villa Formula&trade;</span>
        </div>
      </div>
    </footer>
  );
}
